export default "__VITE_ASSET__C41FSAH5__"